import { createContext } from 'react'

/**
 * What the position cell and the row menu need to move a job (slice 3c): handed down by the panel through the
 * table, which only draws them. Outside a machine tab (or in a table with no panel) `enabled` is false and the
 * position is only a number.
 */
const SequenceMoveContext = createContext({ enabled: false })

export default SequenceMoveContext
